import { render, staticRenderFns } from "./UploadImageTab.vue?vue&type=template&id=ae951b68"
import script from "./UploadImageTab.vue?vue&type=script&lang=js"
export * from "./UploadImageTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports